import { getRouteUrl as getURL } from '@nackle/service-urls';
export const env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'ci', 'qa', 'pprd', 'localhost' ].indexOf( chunk ) >= 0;
} );

function buildURL( url ) {
    return url.toLowerCase().replace( '(env.)', env ? ( env === 'localhost' ? 'qa.' : env + '.' ) : '' );
}

export const idURL = getURL( 'ID_PROVIDER' );
export const rosterURL = getURL( 'ROSTER_PROXY' );
export const cashierURL = getURL( 'CASHIER' );
export const profileURL = getURL( 'PROFILE_SERVICE' );
export const harryURL = getURL( 'HARRY' );
export const solutionsURL = `${ getURL( 'SOLUTION_API' ) }/services/v1`;
export const rosterGroupsUrl = buildURL( 'https://(env.)roster-groups.biw.cloud' );
export const lighthouseURL = getURL( 'LIGHTHOUSE_SERVICE' );
export const fileLoaderHatchURL = buildURL( 'https://(env.)file-loader-hatch.biw.cloud' );
export const accountActivationHatchURL = buildURL( 'https://(env.)account-activation-hatch.biw.cloud' );
export const companyURL = getURL( 'COMPANY_SERVICE' );